export default __webpack_public_path__ + "static/Scroll-Image---Deck-Removal-cdbbda43c9a55823da697a53cb967a44.jpg";